(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name examination.factory:Exam
   *
   * @description
   *
   */
  angular
    .module('vcexam')
    .factory('Exam', Exam)
    .config(config);

  config.$inject = ['restmodProvider'];

  function config(restmodProvider) {
    restmodProvider.rebase({
      $config: {
        primaryKey: '_id'
      }
    });
  }

  Exam.$inject = ['restmod'];

  function Exam(restmod) {
    return restmod.model('/routes/examinations').mix({
      // patient: {belongsTo: 'Client', key: 'clientid'},
      // consult: {belongsTo: 'Consult', key: 'consultid'},
      created: {
        init: function () {
          return moment().toISOString();
        }
      },
      active: {init: true},
      open: {init: true},$extend: {
        Model: {
          $searchahead: function (_params) {
            return this.$collection().$decorate({
              'before-request': function (_req) {
                _req.method = 'GET';
                _req.url = '/routes/examinations/searchahead';
              }
            }, function () {
              return this.$fetch(_params);
            });
          },
          $opengdtshare: function (_params) {
            return this.$collection().$decorate({
              'before-request': function (_req) {
                _req.method = 'GET';
                _req.url = '/routes/examinations/opengdtshare';
              }
            }, function () {
              return this.$fetch(_params);
            });
          },
          $searchBy: function (_params) {
            return this.$collection().$decorate({
              'before-request': function (_req) {
                _req.method = 'GET';
                _req.url = '/routes/examinations';
              }
            }, function (key, val) {
              let realquery = {};
              realquery[key] = val;
              realquery.active = true;
              return this.$search(realquery);
            });
          }
          /*$searchBy: function (key, val) {
            let realquery = {};
            realquery[key] = val;
            return this.$search(realquery);
          },*/
        } // Model
      }// extend
    });
  }
}());
